export default "__VITE_ASSET__B3_2R86Z__"